var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPeopleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.27273C6 10.0802 7.45507 11.5455 9.25 11.5455C11.0449 11.5455 12.5 10.0802 12.5 8.27273C12.5 6.46525 11.0449 5 9.25 5C7.45507 5 6 6.46525 6 8.27273ZM14.125 11.5455C14.125 12.9011 15.2163 14 16.5625 14C17.9087 14 19 12.9011 19 11.5455C19 10.1898 17.9087 9.09091 16.5625 9.09091C15.2163 9.09091 14.125 10.1898 14.125 11.5455Z",
    fill: "#ADB5BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48612 13C5.55159 13 2.32355 15.1232 2.00054 19.2993C1.98295 19.5268 2.39726 20 2.60625 20H16.3722C16.9983 20 17.008 19.471 16.9983 19.3C16.7541 15.0065 13.476 13 9.48612 13ZM21.5466 20H18.3333C18.3333 18.0304 17.7136 16.2129 16.6677 14.7505C19.5064 14.7831 21.8243 16.2901 21.9987 19.475C22.0058 19.6033 21.9987 20 21.5466 20Z",
    fill: "#6C757D"
  })));
}

export default SvgPeopleIcon;